import { EventHint, init, showReportDialog } from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { Event } from '@sentry/types/dist/event';
import { createBrowserHistory } from 'history';

import { isProd, isStage } from './config';
import { store } from './index';
import { flattenMessages } from './utils';

import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import { Locale } from './models/locale.model';
import { INIT } from './store/middlewares/modules/init';
import createStore from './store/store';

export default function initialize() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const lang = ((window.django?.language as string) || 'de') as Locale;
    const messages = { de: de, en: en, it: it, fr: fr };

    const i18nInitialState = {
        locale: lang,
        messages: { ...flattenMessages(messages[lang]) },
    };

    const history = createBrowserHistory({ basename: process.env.REACT_APP_PUBLIC_URL });
    const store = createStore(history, { intl: i18nInitialState });

    return { history, store };
}

export function setUpInitFn() {
    if (isProd || isStage) {
        init({
            dsn: 'https://2676dcf22e954d1c82d3cef4f89c8bc6@o162224.ingest.sentry.io/5805859',
            integrations: [new Integrations.BrowserTracing()],
            beforeSend(event: Event, hint: EventHint | undefined): PromiseLike<Event | null> | Event | null {
                // Check if it is an exception, and if so, show the report dialog
                console.warn('Will report error event to sentry', event, 'hint', hint);

                if (event.exception) {
                    showReportDialog({ eventId: event.event_id });
                }

                return event;
            },
            // We recommend adjusting this value in production, or using tracesSampler for finer control
            tracesSampleRate: 0.01,
        });
    }

    store.dispatch({ type: INIT });
}
